var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "#EB5757",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.16 7.30669L20.6933 1.84002C20.0533 1.20002 18.7733 0.666687 17.8666 0.666687H10.1333C9.22663 0.666687 7.94663 1.20002 7.30663 1.84002L1.83996 7.30669C1.19996 7.94669 0.666626 9.22669 0.666626 10.1334V17.8667C0.666626 18.7734 1.19996 20.0534 1.83996 20.6934L7.30663 26.16C7.94663 26.8 9.22663 27.3334 10.1333 27.3334H17.8666C18.7733 27.3334 20.0533 26.8 20.6933 26.16L26.16 20.6934C26.8 20.0534 27.3333 18.7734 27.3333 17.8667V10.1334C27.3333 9.22669 26.8 7.94669 26.16 7.30669ZM19.3733 17.96C19.76 18.3467 19.76 18.9867 19.3733 19.3734C19.1733 19.5734 18.92 19.6667 18.6666 19.6667C18.4133 19.6667 18.16 19.5734 17.96 19.3734L14 15.4134L10.04 19.3734C9.83996 19.5734 9.58663 19.6667 9.33329 19.6667C9.07996 19.6667 8.82662 19.5734 8.62663 19.3734C8.23996 18.9867 8.23996 18.3467 8.62663 17.96L12.5866 14L8.62663 10.04C8.23996 9.65335 8.23996 9.01335 8.62663 8.62669C9.01329 8.24002 9.65329 8.24002 10.04 8.62669L14 12.5867L17.96 8.62669C18.3466 8.24002 18.9866 8.24002 19.3733 8.62669C19.76 9.01335 19.76 9.65335 19.3733 10.04L15.4133 14L19.3733 17.96Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX2);
export default __webpack_public_path__ + "static/media/x2.4856c14b1dfd91653b625106b0a1af77.svg";
export { ForwardRef as ReactComponent };